export default class PdfString extends String {
  constructor(value: string) {
    super(value);
  }

  toString(): string {
    return `(${this.valueOf()})`;
  }
}
